<div [ngClass]="'clear-input paired-input container'">
  <i *ngIf="!isSearching && !isLoading" [ngClass]="entityOptionsControl.value ? '' : 'hide-opacity'"
     class="bhi-times clear-icon"
     (click)="clearInput(entityInput, true)"></i>
  <span *ngIf="isSearching || isLoading" class="input-loading-spinner spinner-border spinner-border-sm"></span>
  <div class="selected-entity">
    <i [ngClass]="renderIcon(selectedEntity ? entitySelectorsMap[selectedEntity] : '')"
       (click)="clearInput(entityInput, true)"
       [matTooltip]="selectedEntity ? selectedEntity : undefined"
    ></i>
  </div>
  <input
    [@showEntityInput]="!selectedEntity ? 'opened' : 'closed'"
    type="text"
    class="entity-input"
    #entityInput
    [placeholder]="isSearching || isLoading ? 'Loading...' : 'Enter an entity name'"
    [disabled]="isLoading"
    [formControl]="entityOptionsControl"
    [matAutocomplete]="entityOptionAuto"
  >
  <div class="sliding-block"
       [@showRuleInput]="selectedEntity ? 'opened' : 'closed'"
  >
    <span class="divider">|</span>
    <input
      type="text"
      class="rule-input"
      #ruleInput
      [placeholder]="rulePlaceholder"
      [formControl]="ruleOptionsControl"
      [disabled]="isLoading"
      [matAutocomplete]="ruleOptionAuto"
    >
  </div>
</div>
<mat-autocomplete #entityOptionAuto [displayWith]="entityOptionDisplayValue.bind(this)"
                  (optionSelected)="onEntitySelected($event)">
  <mat-option
    *ngFor="let entityOption of $filteredEntities | async" [value]="entityOption.name"
    [ngClass]="'entity-autocomplete-option' + ' ' + entitySelectorsMap[entityOption.name]"
  >
    <i [className]="renderIcon(entitySelectorsMap[entityOption.name])"></i>{{entityOption.label}} ({{entityOption.name}}
    )
  </mat-option>
</mat-autocomplete>
<mat-autocomplete #ruleOptionAuto [displayWith]="ruleOptionDisplayValue.bind(this)"
                  (optionSelected)="onRuleSelected($event)">
  <mat-option *ngFor="let ruleOption of $filteredRules | async" [value]="ruleOption.value"
              [disabled]="ruleOption.used" [matTooltip]="ruleOption.used ? 'Cannot add rule. It is already in a chain or is scheduled' : undefined"
  >
    {{ruleOption.label}}
  </mat-option>
</mat-autocomplete>
